<script>

    import { createEventDispatcher } from 'svelte'

    import { eventStore } from '../stores'

    const dispatch = createEventDispatcher()

    export let eventId = null

    $: $eventStore && $eventStore === eventId && dispatchEvent()

    function dispatchEvent() {

        dispatch('dispatch')

        setTimeout(() => { 
            eventStore.set(null)
         }, 1000)
    }

</script>